
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's07292025d584ef0f': `Close overlay`,
's4bd8b1e7a8147b62': `Galerie`,
's637376fd03047144': `Vorheriges Bild`,
's7ed13ccddb1bf3c3': `Overlay`,
's885970c4ee8d21cc': `Schliessen`,
's9475efd7c1377ea0': `Bildergalerie`,
'sb9e59f1e01eb588e': `Open image gallery`,
'sf592e9ad59fde6e8': `Nächstes Bild`,
    };
  